import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "dateArray" })
export class DateArrayPipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}

  /**
   * Take an array of date strings and map it to formated date
   */
  transform(stringArray: string[], format = ""): string[] {
    return stringArray.map((s) => this.datePipe.transform(s, format));
  }
}

@Pipe({ name: "toDate" })
export class ToDatePipe implements PipeTransform {
  transform(value: string | number | null | undefined): Date | null {
    if (!value) return null;

    let date: Date | null = null;

    if (typeof value === "number") {
      // Timestamp direct
      date = new Date(value);
    } else if (typeof value === "string") {
      const parsed = new Date(value);

      if (!isNaN(parsed.getTime())) {
        // String that js recognizes as a date:
        date = parsed;
      } else {
        // Special formats

        // Hours: "HH:mm" ou "HH:mm:ss"
        const timeMatch = /^(\d{1,2}):(\d{2})(?::(\d{2}))?$/;
        if (timeMatch.test(value)) {
          const [, h, m, s] = value.match(timeMatch)!;
          const now = new Date();
          now.setHours(Number(h), Number(m), s ? Number(s) : 0, 0);
          date = now;
        }
        // Format DD-MM-YYYY
        else if (/^\d{2}-\d{2}-\d{4}$/.test(value)) {
          const [day, month, year] = value.split("-").map(Number);
          date = new Date(year, month - 1, day);
        }
        // Format YYYY/MM/DD ou YYYY-MM-DD
        else if (/^\d{4}[-/]\d{2}[-/]\d{2}$/.test(value)) {
          date = new Date(value.replace(/\//g, "-"));
        }
      }
    }

    return date && !isNaN(date.getTime()) ? date : null;
  }
}
